import { LitElement } from 'lit';
import styles from './toujou-slider-progressbar.css';

class ToujouSliderProgressbar extends LitElement {
  static get is() {
    return 'toujou-slider-progressbar';
  }

  static get styles() {
    return styles;
  }

  static get properties() {
    return {
      animationPaused: {
        type: Boolean,
        reflect: true,
      },
    };
  }

  constructor(props) {
    super(props);

    // Get a reference to the slider element in which the progressbar exists
    this._slider = this.parentNode;

    // Event Listeners
    this._slider.addEventListener('glider-slide-visible', this._addAnimation.bind(this));
    this._slider.addEventListener('glider-slide-hidden', this._removeAnimation.bind(this));
    this._slider.addEventListener('glider-reset-animation', this._resetAnimation.bind(this));
    this._slider.addEventListener('mouseenter', this._pauseAnimation.bind(this));
    this._slider.addEventListener('mouseleave', this._unpauseAnimation.bind(this));

    // Run the reset function when the element is ready
    this._resetAnimation();
  }

  /**
   * Start animating
   *
   * @private
   */
  _addAnimation() {
    setTimeout(() => {
      this.setAttribute('animated', '');
    });
  }

  /**
   * Remove animating
   *
   * @private
   */
  _removeAnimation() {
    this.removeAttribute('animated');
  }

  /**
   * Reset animation
   *
   * @private
   */
  _resetAnimation() {
    this._removeAnimation();
    this._addAnimation();
  }

  /**
   * Pause the animation
   *
   * @private
   */
  _pauseAnimation() {
    this.animationPaused = true;
  }

  /**
   * Unpause the animation
   *
   * @private
   */
  _unpauseAnimation() {
    this.animationPaused = false;
    this._resetAnimation();
  }
}

customElements.define(ToujouSliderProgressbar.is, ToujouSliderProgressbar);
